<div>{{value ?? '&nbsp;'}}</div>